module.exports = __webpack_public_path__ + "static/media/profile-background.e7fb21bd.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/screenshots/profile-background.jpg
 ** module id = 432
 ** module chunks = 0
 **/